import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    ElementRef, OnChanges, SimpleChanges
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CommonDataService} from 'app/services/common-data.service';
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {TabInfoBase} from "../../models/tab-info-base";
import {BGChartType} from "../../models/b-g-chart-type";
import {ISubscription} from "rxjs/Subscription";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import * as moment from "moment";
import {ChartLineModel} from "../../models/amchart/chart-line-model";
import {
    GenerateLinesGUID,
    HoverLineGUID, LoadingSummaryLineDataGUID, UpdateChartAggGUID, UpdateChartGUID,
    UpdateInfoParamGUID,
    UpdateStaticPopupGUID
} from "../../models/update-static-popup-GUID";
import {ChartAggModel} from "../../models/amchart/chart-aggregation";
import {ChartData} from "../../models/chart-data";
import {ChartDataRow} from "../../models/chart-data-row";
import {MainHelper} from "../../../shared/models/main-helper";

@Component({
    selector: 'chart-info',
    templateUrl: './chart-info.component.html',
    styleUrls: ['./chart-info.component.css']
})
export class ChartInfoComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges{

    constructor(public readonly translateService: TranslateService,
                public readonly commonData: CommonDataService,
                private readonly dataExchange: BufferGraphDataExchangeService,
    ){
        this.helper = new ChartHelper();
        this.updateState = new EventEmitter<boolean>();
        this.showAgg = true;
        this.agg = [];
    }

    @Input() public type: BGChartType;
    @Input() public GUID: string;
    @Input() public sharedGUID: string;
    @Input() public hasCompareChart: boolean;


    @Output()
    public readonly updateState: EventEmitter<boolean>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    public helper: ChartHelper;
    public initialized: boolean;
    public showInfo: boolean;
    public stpDate: string;
    public freezeDataChange: boolean;
    public info: ChartLineModel[];
    public infoBubble: ChartLineModel[];
    public loadingSummaryLineData: boolean;
    public showAgg: boolean;
    public agg: ChartAggModel[];
    public aggPeriod: string
    public chart: any;
    public dateAxis: any;
    public chartData: ChartData;
    public chartDataRowObj: {[key: string]: ChartDataRow};
    public bubbleChart: any;
    public bubbleDateAxis: any;
    private bubbleChartData: any[];
    public compareChart: any;
    public compareDateAxis: any;
    public compareChartData: ChartData;
    public compareChartDataRowObj: {[key: string]: ChartDataRow};
    public compareBubbleChart: any;
    public compareBubbleDateAxis: any;
    private compareBubbleChartData: any[];

    public translates: {[key: string]: string};
    private subscriptionToggleChartInfo: ISubscription;
    private subscriptionUpdateStaticPopup: ISubscription;
    private subscriptionUpdateInfoParam: ISubscription;
    private subscriptionGenerateInfoLines: ISubscription;
    private subscriptionLoadSummaryLineData: ISubscription;
    private subscriptionUpdateLineVisibility: ISubscription;
    private subscriptionUpdateAggregations: ISubscription;
    private subscriptionUpdateChartObj: ISubscription;

    public get chartType(): typeof BGChartType{
        return BGChartType;
    }

    async ngOnInit(){

        //# toggle visibility info for main and compare chart
        this.subscriptionToggleChartInfo = this.dataExchange.toggleChartInfoCurrent.subscribe((r: { type: BGChartType, sharedGUID: string, show: boolean }) =>
            this.helper.tryCatch(() => {
                if (r && (this.type === r.type || this.sharedGUID === r.sharedGUID)){
                    this.showInfo = r.show;
                }
            })
        );

        /**
         * update static popup data
         */
        this.subscriptionUpdateStaticPopup = this.dataExchange.chartCalcStaticPopupCurrent.subscribe((r: UpdateStaticPopupGUID) =>
            this.helper.tryCatch(() => {
                if (r && this.sharedGUID === r.GUID){
                    this.updateStaticPopup(r.isMainChart, this.hasCompareChart)
                }
            })
        );

        this.subscriptionUpdateInfoParam= this.dataExchange.chartUpdateInfoParamCurrent.subscribe((r: UpdateInfoParamGUID) =>
            this.helper.tryCatch(() => {
                // console.log(r, 'UpdateInfoParamGUID')
                if (r && this.sharedGUID === r.GUID && r.param){
                    this[r.param] = r.val;
                }
            })
        );

        this.subscriptionGenerateInfoLines = this.dataExchange.chartGenerateInfoLinesCurrent.subscribe((r: GenerateLinesGUID) =>
            this.helper.tryCatch(() => {
                if (r && this.sharedGUID === r.GUID){
                    this.info = r.chartLines.filter(item => item);
                    this.info.sort(function (a: ChartLineModel, b: ChartLineModel){
                        return a.position - b.position;
                    });

                    this.infoBubble = r.bubbleChartLines.filter(item => !item.hideLineInLegend);
                    this.infoBubble.sort(function (a: ChartLineModel, b: ChartLineModel){
                        return a.position - b.position;
                    });

                    this.dataExchange.setChartLinesData(new GenerateLinesGUID(this.sharedGUID, this.info, this.infoBubble))
                }
            })
        );

        //# toggle hover lines in charts, main and compare chart
        this.subscriptionLoadSummaryLineData = this.dataExchange.chartLoadSummaryLineDataCurrent.subscribe((r: LoadingSummaryLineDataGUID) =>
            this.helper.tryCatch(() => {
                if (r && r.GUID === this.sharedGUID){
                    this.selectChart(r);
                }
            })
        );

        //# toggle visibility lines in charts, main and compare chart
        this.subscriptionUpdateLineVisibility = this.dataExchange.toggleLinesVisibilityCurrent.subscribe(r =>
            this.helper.tryCatch(() => this.updateLineVisibility(r))
        );

        //# set aggregations
        this.subscriptionUpdateAggregations = this.dataExchange.chartUpdateAggregationsCurrent.subscribe((r: UpdateChartAggGUID) =>
            this.helper.tryCatch(() => {
                if (r && r.GUID === this.sharedGUID){
                    // console.log(this.agg, r, 'subscriptionUpdateAggregations')
                    this.updateAggregation(r);
                }
            })

        );

        //# set chart data
        this.subscriptionUpdateChartObj = this.dataExchange.chartObjUpdateCurrent.subscribe((r: UpdateChartGUID) =>
            this.helper.tryCatch(() => {
                if (r && r.GUID === this.sharedGUID){
                    if (r.isMainChart){
                        this.chart = r.chart;
                        this.dateAxis = r.dateAxis;
                        this.chartData = r.chartData;
                        this.chartDataRowObj = this.helper.arrToObj(r.chartData.rows, 'date');
                        this.bubbleChart = r.bubbleChart;
                        this.bubbleDateAxis = r.bubbleDateAxis;
                        this.bubbleChartData = r.bubbleChartData;
                    } else {
                        this.compareChart = r.chart;
                        this.compareDateAxis = r.dateAxis;
                        this.compareChartData = r.chartData;
                        this.compareChartDataRowObj = this.helper.arrToObj(r.chartData.rows, 'date');
                        this.compareBubbleChart = r.bubbleChart;
                        this.compareBubbleDateAxis = r.bubbleDateAxis;
                        this.compareBubbleChartData = r.bubbleChartData;
                    }

                }
            })

        );

        this.translates = this.translates = await this.translateService.get(['NoData', 'Date', 'OffShort', 'OnShort', 'Rows', 'Goods', 'Warehouses']).toPromise();
        this.initialized = true;
    }

    ngOnDestroy(){
        this.subscriptionToggleChartInfo.unsubscribe();
        this.subscriptionUpdateStaticPopup.unsubscribe();
        this.subscriptionUpdateInfoParam.unsubscribe();
        this.subscriptionGenerateInfoLines.unsubscribe();
        this.subscriptionLoadSummaryLineData.unsubscribe();
        this.subscriptionUpdateLineVisibility.unsubscribe();
        this.subscriptionUpdateAggregations.unsubscribe();
        this.subscriptionUpdateChartObj.unsubscribe();
    }

    ngAfterViewInit(){

    }

    ngOnChanges(changes: SimpleChanges){
        if (changes['hasCompareChart'] && !changes['hasCompareChart'].firstChange && changes['hasCompareChart'].currentValue !==  changes['hasCompareChart'].previousValue){
            this.hasCompareChart = changes['hasCompareChart'].currentValue;
        }
    }

    // Updates values for info, line chart
    private updateStaticPopup = (isMainChart: boolean, updateOtherChart: boolean): void => {
        let date: Date = null,
            chart = isMainChart ? this.chart : this.compareChart,
            dateAxis = isMainChart ? this.dateAxis : this.compareDateAxis;

        if (!chart){
            return;
        }

        let cursor: any;
        if (isMainChart){
            if (!this.hasCompareChart){
                cursor = this.chart.cursor;
            } else{
                cursor = updateOtherChart ? this.chart.cursor : this.compareChart.cursor;
            }
        } else {
            cursor = updateOtherChart ? this.compareChart.cursor : this.chart.cursor
        }
        // console.log(isMainChart, dateAxis, updateOtherChart, 'updateStaticPopup');
        // console.log(isMainChart, updateOtherChart, this.hasCompareChart, cursor, 'updateStaticPopup');

        chart.series.each((series) => {
            date = date ? date : this.getDate(series, dateAxis, isMainChart, cursor);
            let line: ChartLineModel = this.info.find(item => series.dummyData.name === item.name);

            if (!line){
                return
            }

            if (isMainChart){

            }

            if (series.visible){
                let dataItem: any = this.getDataItem(series, dateAxis, isMainChart, cursor);

                if (!dataItem){
                    return;
                }

                if (isMainChart){
                    // console.log(line.name, dataItem, 'dataItem')
                }

                let dateMoment = moment(date),
                    isoString = dateMoment.format(MainHelper.dateFormat) + 'T' + dateMoment.format(MainHelper.timeFormat) + 'Z';

                if (this.chartDataRowObj[isoString]){
                    line.count = this.chartDataRowObj[isoString][line.name + 'Count'];
                    // console.log(line.name, line.count, this.chartDataRowObj[isoString], 'chartDataRowObj')
                    if (line.name === 'cancellation'){
                        // console.log(line.count, this.chartDataRowObj[isoString], 'chartDataRowObj')
                    }

                }

                if (dataItem["valueY"] === undefined || dataItem["valueY"] === null){
                    line[isMainChart ? 'value' : 'compareValue'] = this.translates.NoData;
                } else{
                    switch (line.name){
                        case 'actionBuffer':
                            line[isMainChart ? 'value' : 'compareValue'] = chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.bufferG);
                            break;
                        case 'bufferG':
                            // line.value = this.chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.safetyBuffer - dataItem.dataContext.actionSafetyBuffer);
                            line[isMainChart ? 'value' : 'compareValue'] = chart.numberFormatter.format(dataItem.dataContext.actionBuffer - dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'bufferY':
                            line[isMainChart ? 'value' : 'compareValue'] = chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'bufferR':
                            line[isMainChart ? 'value' : 'compareValue'] = chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'safetyBuffer':
                            line[isMainChart ? 'value' : 'compareValue'] = chart.numberFormatter.format(dataItem.dataContext.actionSafetyBuffer);
                            break;
                        case 'actionSafetyBuffer':
                            line[isMainChart ? 'value' : 'compareValue'] = chart.numberFormatter.format(dataItem["valueY"] - dataItem.dataContext.safetyBuffer);
                            break;
                        default:
                            line[isMainChart ? 'value' : 'compareValue'] = chart.numberFormatter.format(dataItem["valueY"]);
                    }
                }
            } else{
                line[isMainChart ? 'value' : 'compareValue'] = this.translates.OffShort;
                line.count = this.translates.OffShort;

            }
        });

        if (updateOtherChart){
            this.updateStaticPopup(!isMainChart, false)
        }

        this.updateStaticPopupBubble(isMainChart, date, updateOtherChart)
    };

    // Updates values for info, bubble chart
    private updateStaticPopupBubble = (isMainChart: boolean, date: Date, updateOtherChart: boolean): void => {
        let bubbleChart = isMainChart ? this.bubbleChart : this.compareBubbleChart
        if (!bubbleChart){
            return;
        }

        bubbleChart.series.each((series) => {
            let line: ChartLineModel = this.infoBubble.find(item => series.dummyData.name === item.name);

            if (!line){
                return
            }

            let cDate = moment(date).format(MainHelper.dateFormat) + 'T00:00:00Z',
                bubbleChartData = isMainChart ? this.bubbleChartData : this.compareBubbleChartData;


            line[isMainChart ? 'value' : 'compareValue'] = bubbleChartData.find(item => item[series.dummyData.name] && cDate === item.date) ? '1' : '';
            // }
        })
        if (updateOtherChart){
            this.updateStaticPopupBubble(!isMainChart, date, false)
        }
    };


    //# get date item obj from date axis and set date for info header
    private getDate = (series: any, dateAxis: any, isMainChart: boolean, cursor: any): Date => {
        let dataItem: any = this.getDataItem(series, dateAxis, isMainChart, cursor);

        if (!dataItem || dataItem && !dataItem['dateX']){
            return null
        }

        if (['ru', 'uk', 'lt', 'pl'].includes(this.translateService.currentLang)){
            this.stpDate = moment(dataItem['dateX']).format('DD.MM.YYYY')
        } else{
            this.stpDate = moment(dataItem['dateX']).format('YYYY.MM.DD')
        }
        return dataItem['dateX'];
    };

    //# get date item obj from date axis
    private getDataItem = (series: any, dateAxis: any, isMainChart: boolean, cursor: any): any => {
        let dataItem: any;
        let chart = isMainChart ? this.chart : this.compareChart;

        if (dateAxis){
            // console.log(series, dateAxis, dateAxis.toAxisPosition(chart.cursor.xPosition), 'getDataItem')
            dataItem = dateAxis.getSeriesDataItem(
                series,
                dateAxis.toAxisPosition(cursor.xPosition),
                true
            );
        } else{
            dataItem = series.dataItems.last;
        }

        return dataItem
    }

    //# send message to service for update line visibility for line chart in main and compare chart
    public toggleShowLines = (lineName: string, chartType: string): void => {
        this.dataExchange.setToggleLinesVisibility({
            type: this.type,
            sharedGUID: this.sharedGUID,
            lineName: lineName,
            chart: chartType
        });
    };

    /**
     * hover lines for chart
     * @param lineName
     * @param chart
     * @param hover
     */
    public readonly hoverLine = (lineName: string, chart: 'bubble' | 'line', hover: boolean): void => {
        this.dataExchange.setHoverLine(new HoverLineGUID(this.sharedGUID, lineName, chart, hover))
    }

    public readonly onSelectChart = (item: ChartLineModel): void => {
        if (this.loadingSummaryLineData){
            return;
        }

        this.dataExchange.setLoadSummaryLineData(new LoadingSummaryLineDataGUID(this.sharedGUID, item, true, false));
        this.updateLines(item);
    }

    //# send message to service for update line visibility for line chart in main and compare chart
    public selectChart = (item: LoadingSummaryLineDataGUID): void => {
        if (item.loadEnd){
            this.loadingSummaryLineData = false;
            return;
        }
    };

    /**
     * update line selection and set loading
     * @param line which we selected
     */
    private readonly updateLines = (line: ChartLineModel): void => {
        if (line.summaryLineSelected){
            this.info.forEach(i => i.summaryLineSelected = false);
            // item.summaryLineSelected = false;
        } else{
            this.info.forEach(i => i.summaryLineSelected = i.name === line.name);
            this.loadingSummaryLineData = true;
        }
    }

    //# get message from service for update line visibility for line chart in main and compare chart
    private updateLineVisibility = (data: { type: BGChartType, sharedGUID: string, lineName: string, chart: string }): void => {
        if (data && data.type === this.type && data.sharedGUID === this.sharedGUID){
            let lineName = data.lineName;
            // console.log(data, 'updateLineVisibility')
            if (data.chart === 'lines'){
                let line = this.info.find(item => item.name === lineName);

                if (!line || line.hideLineInLegend && line.name !== 'targetStockLevel'){
                    return;
                }

                line.enabled = !line.enabled;
            } else if (data.chart === 'bubble'){
                let line = this.infoBubble.find(item => item.name === lineName);

                line.enabled = !line.enabled;
            }

        }
    }

    /**
     * Update aggregation data
     * @param val
     */
    private readonly updateAggregation = (val: UpdateChartAggGUID): void => {
        this.aggPeriod = val.period;
        if (!this.agg.length){
            this.agg = val.agg
        } else {
            const currentAgg = (inner: ChartAggModel, outer: ChartAggModel): boolean => {
                return inner.agg === outer.agg && inner.name === outer.name;
            }

            if (val.isMainChart){
                this.agg.forEach(ca => val.agg.forEach(va => {
                    if (currentAgg(ca, va)){
                        ca.value = va.value;
                    }
                }))
            } else {
                this.agg.forEach(ca => val.agg.forEach(va => {
                    if (currentAgg(ca, va)){
                        ca.compareValue = va.value;
                    }
                }))
            }
        }
    }

}




// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/chart-info.component/chart-info.component.ts